import { render, staticRenderFns } from "./TabTomador.vue?vue&type=template&id=d4aa662e&"
import script from "./TabTomador.vue?vue&type=script&lang=js&"
export * from "./TabTomador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports